module.exports = __webpack_public_path__ + "static/media/pricing.3f151d8b.png";